import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export default ({ app, route, error, req }) => {
  const i18n = new VueI18n({"messages":{"enUS":{"request":{"abrAdr":{"changeFormat":"Change Format","unstructured-label":"I need to use a different format for my address.","structured-label":"Use the standard international format for my address."},"fwdAdr":{"changeFormat":"Change Format","unstructured-label":"I need to use a different format for my address.","structured-label":"Use the standard international format for my address."},"fpcaDownload":{"downloadedAlertMessage":"Your form has been downloaded (check your downloads folder).  You must **SIGN, DATE and SEND** it to your election official."}}},"esES":{"request":{"abrAdr":{"changeFormat":"Cambiar formato","structured-label":"Uso el formato estándar internacional para mi domicilio.","unstructured-label":"Necesito utilizar un formato diferente para mi domicilio."},"fwdAdr":{"changeFormat":"Cambiar formato","structured-label":"Use el formato estándar internacional para mi domicilio.","unstructured-label":"Necesito utilizar un formato diferente para mi domicilio."},"fpcaDownload":{"downloadedAlertMessage":"Su formulario ha sido descargado (revise su carpeta de descargas). Debe **FIRMARLO, FECHARLO y ENVIARLO** a su funcionario electoral."}}}},"fallbackLocale":"enUS"})
  app.i18n = i18n
  app.i18n.locales = [{"code":"enUS","iso":"en-US","name":"English","langFile":"en-US.json"},{"code":"esES","iso":"es-ES","name":"Español","langFile":"es-ES.json"}]
  app.i18n.defaultLocale = 'enUS'
  app.i18n.ignorePaths = []
  app.i18n.differentDomains = false
  app.i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {}
  app.i18n.onLanguageSwitched = (oldLocale, newLocale) => {}

  // Get locale from params
  let locale = app.i18n.defaultLocale || null
  if (false) {
    const hostname = process.browser ?
      window.location.href.split('/')[2] : req.headers.host
    if (hostname) {
      const localeDomain = app.i18n.locales.find(l => l.domain === hostname)
      if (localeDomain) {
        locale = localeDomain.code
      }
    }
  } else {
    // Get locale from params
    app.i18n.locales.forEach(l => {
      const regexp = new RegExp('^/' + l.code + '(/.+)?')
      if (route.path.match(regexp)) {
        locale = l.code
      }
    })
    if (app.i18n.locales.findIndex(l => l.code === locale) === -1) {
      return error({ message: 'Page not found.', statusCode: 404 })
    }
  }
  app.i18n.locale = locale
  if (true) {
    const { loadLanguageAsync } = require('./i18n.utils')
    return loadLanguageAsync(app.i18n, app.i18n.locale)
  }
}
